import React from 'react';
import {createRef} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Page from './page';
import ReactPlayer from 'react-player';
import screenfull from 'screenfull';
import {navigateNext} from '../../action/actions';
import Api from '../../util/api';
import Button from "./Button";

class Animation extends React.Component {
    state = {
        playing: false,
        played: false,
    }
    playerRef = createRef();

    componentDidMount() {
        this.setTimeout = setTimeout(() => {
            this.handleStart()
        }, 100);
    }

    handleEnded = () => {
        setTimeout(() => {
            screenfull.exit();
            Api.navigateDeviceNext().then(this.props.navigateNext);
        }, 100);
    }

    handleStart = () => {
        if (screenfull.isEnabled) {
            screenfull.request(this.playerRef.current.wrapper)
                .then(() => this.setState({playing: true}))
                .catch(() => console.log('Requires manual start'));
        }
    }

    skip = () => {
        Api.navigateDeviceNext().then(this.props.navigateNext);
    }

    render = () => {
        const {animation} = this.props;
        const {playing, showStartButton} = this.state;

        return (
            <Page title={'Animatie'}>
                <div className={'bodyContainer'}>
                    <div className={'bodyContainerColumn'}>
                        <ReactPlayer ref={this.playerRef} playing={playing} url={animation} onEnded={this.handleEnded}
                                     style={{
                                         width: '100%',
                                         height: '100%',
                                     }}/>
                    </div>
                    <div className={'bodyContainerColumn'}>
                        <div style={{width: '250px'}}>
                            <Button onClick={this.handleStart} color={'pink'} text={'Start schermvullend'}/>
                            {/* <Button onClick={this.skip} color={'red'} text={'Skip'}/> */}
                        </div>
                    </div>
                </div>
            </Page>
        );
    }
}

Animation.propTypes = {
    animation: PropTypes.string.isRequired,
}

const mapDispatchToProps = (dispatch) => ({
    navigateNext: () => dispatch(navigateNext()),
});

export default connect(null, mapDispatchToProps)(Animation);
